import AboutInspection from './AboutInspection/index.vue';
import OrderInspection from './OrderInspection/index.vue';
import ConfirmationMessage from './ConfirmationMessage/index.vue';

export default {
  props: ['advertisementsData'],
  components: {
    AboutInspection,
    OrderInspection,
    ConfirmationMessage,
  },
  data() {
    return ({
      cities: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 18, 19, 20, 22,
        24, 55, 76, 140, 161, 200, 291, 297, 302, 418, 605, 17829, 17880],
      currentStep: 'AboutInspection',
      orderId: null,
      price: 1700,
    });
  },
  computed: {
    isVinnytsiaState() {
      const stateId = Number(this.advertisementsData?.location?.state?.id);

      return stateId === 1;
    },
    targetCities() {
      const citiId = Number(this.advertisementsData?.location?.city?.id);
      return this.cities.includes(citiId);
    },
    confirmationMessageProps() {
      return this.currentStep === 'ConfirmationMessage' ? { orderId: this.orderId } : {};
    },
    orderInspectionProps() {
      return this.currentStep === 'OrderInspection' ? { advertisementsData: this.advertisementsData } : {};
    },
  },
  methods: {
    orderInspection(value) {
      this.currentStep = value?.name;
      if (value?.id) this.orderId = value?.id;

      const element = document.getElementById('onSiteInspection');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    },
  },
};
